/*import React from "react";
import "./Charts.css"
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

function Charts({ title, data, dataKey, grid }){
    
    return(
        <div className="chart">
            <h3 className="chartTitle">{title}</h3>
            <ResponsiveContainer className="responsive" aspect={2}>
                <LineChart data={data}>
                    <XAxis dataKey="name" stroke="#43b87d"/>
                    <Line type="monotone" dataKey={dataKey} stroke="#43b87d" />
                    <Tooltip />
                    {grid &&<CartesianGrid stroke="#e0dfdf" strokeDasharray="5 5"/>}
                </LineChart>
            </ResponsiveContainer>
        </div>
    )
}

export default Charts;*/

import React from 'react'
import { Line } from 'react-chartjs-2'
import { MDBContainer } from 'mdbreact'
import "./Charts.css"

class Charts extends React.Component {
    state = {
        dataLine: {
            labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
            datasets: [
                {
                    label: 'first one',
                    fill: true,
                    backgroundColor: "rgba(240, 26, 229,0.3)",
                    borderColor: "rgba(240, 26, 229,0.9)",
                    pointBackgroundColor: "rgb(255,255,255)",
                    pointHoverBackgroundColor: "rgb(0,0,0)",
                    pointBorderColor: "rgba(240, 26, 229,0.9)",
                    pointRadius: 6,
                    pointHoverRadius: 12,
                    data: [50, 100, 20, 10, 30, 40]
                },
                {
                    label: 'second one',
                    fill: true,
                    backgroundColor: "rgba(26, 240, 147,0.3)",
                    borderColor: "rgba(26, 240, 147,0.9)",
                    pointBackgroundColor: "rgb(255,255,255)",
                    pointHoverBackgroundColor: "rgb(0,0,0)",
                    pointBorderColor: "rgba(26, 240, 147,0.9)",
                    pointRadius: 6,
                    pointHoverRadius: 12,
                    data: [100, 200, 300, 10, 20, 50]
                }
            ]
        }
    }
    render() {
        console.log(this.state.dataLine);
        return (
            <div className="chart">
                {/* <Line data={this.state.dataLine} options={{ responsive: true }} /> */}
            </div>
        );
    }
}
export default Charts;